module.exports = __webpack_public_path__ + "static/img/tn_3.c32b9bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダー系/tn_3.png
// module id = 970
// module chunks = 1